// import { regenAdmin } from "../utils/axios";
import { regenBasic, regen } from "../utils/axios";
import { getUserId } from "../utils/jwt";
import { getDeviceId } from "../utils/jwt";

export const searchProducts = async (query) => {
  const url = `/products/?search=${query}`;
  const { data } = await regenBasic.get(url);
  return data;
};

export const getBundles = async ({ pageParam = 1 }) => {
  const userId = getUserId();
  const url = `/recommendations/${userId}?page=${pageParam}&perPage=10`;
  const { data } = await regenBasic.get(url);
  return data;
};

export const getBundleById = async (bundleId) => {
  const userId = getUserId();
  const url = `/recommendations/${userId}/bundle/${bundleId}`;
  const { data } = await regenBasic.get(url);
  return data;
};

export const getBundleByToken = async (token) => {
  const userId = getUserId();
  const url = `/recommendations/${token}/userId/${userId}`;
  const { data } = await regenBasic.get(url);
  return data;
};

export const createBundle = async (bundle) => {
  const userId = getUserId();
  const url = `/recommendations/${userId}`;

  // Create FormData for file upload support
  const formData = new FormData();
  formData.append('bundleName', bundle.bundleName);

  // Add items to FormData
  if (bundle.items && bundle.items.length > 0) {
    bundle.items.forEach(item => {
      formData.append('items', typeof item === 'string' ? item : item.sku);
    });
  }

  // Add instructions if provided
  if (bundle.instructions) {
    formData.append('instructions', bundle.instructions);
  }

  // Add file if provided
  if (bundle.file) {
    formData.append('file', bundle.file);
  }

  const { data } = await regenBasic.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const updateBundle = async (bundle) => {
  const { bundleId, ...bundleData } = bundle;
  const userId = getUserId();
  const url = `/recommendations/${userId}/bundle/${bundleId}`;

  // Create FormData for file upload support
  const formData = new FormData();

  if (bundleData.bundleName) {
    formData.append('bundleName', bundleData.bundleName);
  }

  // Add items to FormData
  if (bundleData.items && bundleData.items.length > 0) {
    bundleData.items.forEach(item => {
      formData.append('items', typeof item === 'string' ? item : item.sku);
    });
  }

  // Add instructions if provided
  if (bundleData.instructions) {
    formData.append('instructions', bundleData.instructions);
  }

  if (bundleData.file) {
    formData.append('file', bundleData.file);
  }

  const { data } = await regenBasic.put(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const deleteBundle = async (bundleId) => {
  const userId = getUserId();
  const url = `/recommendations/${userId}/bundle/${bundleId}`;
  const { data } = await regenBasic.delete(url);
  return data;
};

export const deleteBundleFile = async ({bundleId}) => {
  const userId = getUserId();
  const url = `/recommendations/${userId}/bundle/${bundleId}/file`;
  const { data } = await regenBasic.delete(url);
  return data;
};

export const searchBundle = async (bundleName) => {
  const userId = getUserId();
  const url = `/recommendations/${userId}/search/${bundleName}`;
  const { data } = await regenBasic.get(url);
  return data;
};

export const downloadBundleReport = async (bundleId) => {
  const userId = getUserId();
  const url = `/recommendations/user/${userId}/report/${bundleId}`;
  const { data } = await regenBasic.get(url);
  return data;
};


export const getAdminBundleByToken = async (token) => {
  const userId = getUserId();
  const deviceId = getDeviceId();
  const url = `/admin/bundle/${token}/user/${userId ? userId : deviceId}`;
  const { data } = await regenBasic.get(url);
  return data;
};

export const getBundleForRetail = async () => {
  const userId = getUserId();
  const url = `/recommendations/user/${userId}`;
  const { data } = await regenBasic.get(url);
  return data;
}

export const addBundleToCart = async (token) => {
  const url = `/recommendations/${token}`;
  const { data } = await regen.put(url, { token });
  return data;
}